import React from "react";
import { Alert, Form, Icon, Button, Select, Checkbox, Row, Col } from "antd";
import get from "lodash/get";
import uniq from "lodash/uniq";
import { connect } from "react-redux";

import {
  getBulkSites,
  getBulkSiteRoles,
  copyBulkSitePermissions,
} from "../../api/requests";

import classes from "./CopySitePermissionsForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class CopySitePermissionsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
      roles: [],
      rolesKeys: [],
      shiftDown: false,
    };
  }

  async componentDidMount() {
    const { data: sites } = await getBulkSites();
    this.setState({ sites });
    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  onTargetKeyChange = (index, key) => (e) => {
    const isChecked = e.target.checked;
    const { rolesKeys, roles, shiftDown } = this.state;
    if (rolesKeys.length && shiftDown) {
      const lastCheckedItemIndex = roles.findIndex(
        (item) => item.key === rolesKeys[rolesKeys.length - 1]
      );

      let newItems = [];

      if (lastCheckedItemIndex < index) {
        newItems = roles.reduce((result, item, itemIndex) => {
          return itemIndex > lastCheckedItemIndex && itemIndex <= index
            ? [...result, item.key]
            : result;
        }, []);
      } else {
        newItems = roles.reduce((result, item, itemIndex) => {
          return itemIndex < lastCheckedItemIndex && itemIndex >= index
            ? [...result, item.key]
            : result;
        }, []);
      }

      this.setState(({ rolesKeys }) => ({
        rolesKeys: uniq([...rolesKeys, ...newItems]),
      }));
    } else {
      this.setState(({ rolesKeys }) => ({
        rolesKeys: isChecked
          ? uniq([...rolesKeys, key])
          : uniq(rolesKeys.filter((item) => item !== key)),
      }));
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { rolesKeys } = this.state;

    // const rolesChecked = Object.keys(this.state.rolesChecked)
    //   .filter((key) => !!this.state.rolesChecked[key])
    //   .map((key) => +key);

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        if (!rolesKeys.length) {
          this.setState({
            requestResult: {
              type: "warning",
              message: this.props.i18n.t('NamespaceCopySitePermissionsForm:Please, select role to copy'),
            },
          });
          return;
        }

        this.setState({ isLoading: true });

        try {
          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t('Success') },
          });

          await copyBulkSitePermissions({
            from_site_id: values.from_site_id,
            to_site_id: values.to_site_id,
            from_user_roles_ids: rolesKeys,
          });

          setTimeout(() => {
            this.props.onSubmit();
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });
        }
      }
    });
  };

  getSiteRoles = async (siteId) => {
    this.setState({ roles: [] });
    const { data: roles } = await getBulkSiteRoles(siteId);
    this.setState({
      roles: roles.map((role) => ({
        key: role.id,
        name: role.name,
        chosen: false,
      })),
    });
  };

  render() {
    const { isLoading, requestResult, sites, roles, rolesKeys } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">{this.props.i18n.t('NamespaceCopySitePermissionsForm:Copy site permissions')}</h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceCopySitePermissionsForm:Source site')}:</b>
                <Form.Item>
                  {getFieldDecorator("from_site_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t('Select Site')}
                      onChange={this.getSiteRoles}
                      showSearch
                      optionFilterProp="children"
                      // filterOption={(input, option) =>
                      //   option.props.children
                      //     .toLowerCase()
                      //     .indexOf(input.toLowerCase()) >= 0
                      // }
                    >
                      {sites.map((site) => (
                        <Option
                          key={site.id}
                          value={site.id}
                          disabled={getFieldValue("to_site_id") === site.id}
                        >
                          {site.code} - {site.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col md={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceCopySitePermissionsForm:Destination site')}:</b>
                <Form.Item>
                  {getFieldDecorator("to_site_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  })(
                    <Select
                      placeholder={this.props.i18n.t('Select Site')}
                      showSearch
                      optionFilterProp="children"
                      // filterOption={(input, option) =>
                      //   option.props.children
                      //     .toLowerCase()
                      //     .indexOf(input.toLowerCase()) >= 0
                      // }
                    >
                      {sites.map((site) => (
                        <Option
                          key={site.id}
                          value={site.id}
                          disabled={getFieldValue("from_site_id") === site.id}
                        >
                          {site.code} - {site.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row>
            <Col>
              {roles.length > 0 && (
                <div style={{ paddingBottom: "12px" }}>
                  <label>
                    <Checkbox
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState(() => ({
                            rolesKeys: roles.map(({ key }) => key),
                          }));
                        } else {
                          this.setState(() => ({
                            rolesKeys: [],
                          }));
                        }
                      }}
                    />
                    <b>
                      &nbsp; {this.props.i18n.t('Check all')} &nbsp; ({rolesKeys.length}/{roles.length}
                      )
                    </b>
                  </label>
                </div>
              )}

              {roles.map(({ key, name }, i) => (
                <div key={key} style={{ paddingBottom: "4px" }}>
                  <label>
                    <Checkbox
                      checked={
                        rolesKeys.findIndex((targetKey) => targetKey === key) >
                        -1
                      }
                      onChange={this.onTargetKeyChange(i, key)}
                    />
                    &nbsp;
                    {name}
                  </label>
                </div>
              ))}

              <br />
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={classes.submitButton}
                disabled={isLoading}
              >
                {this.props.i18n.t('Submit')}
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
              <Button
                type="default"
                size="large"
                htmlType="button"
                className={classes.submitButton}
                onClick={this.props.onCancel}
              >
                {this.props.i18n.t('Cancel')}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (_) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "drugShip" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(CopySitePermissionsForm))
);



// WEBPACK FOOTER //
// ./src/components/CopySitePermissionsForm/CopySitePermissionsForm.js